import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './UserHistoryEditor.html?raw';
import _StatefulSection from '../../../../../moreCore/UI/_StatefulSection/_StatefulSection';


class UserHistoryEditor extends compose(_StatefulSection) {
    templateString: any = template;

    afterSetData() {
        let data = this.sourceData;
    }

    onDirtyChange(currentState: boolean) {

    }

    _onChanged(key: string, value: any) {

        this.emit("UserHistoryEditor_ChacgedData", this.changedData)
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(UserHistoryEditor);
